import styled from "styled-components"

export const Buildings = styled.img`
  margin: 0;
  height: auto;
  width: 100%;
`

export default Buildings
